import React, { useRef, Component } from 'react';
import { useLang } from '../context/LanguageContext';
import Lanyard from './Lanyard';
import PortraitChat from './PortraitChat';
import { getLanyardContent } from '../lanyardDefaults';

class LanyardErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default function Hero({ profile }) {
  const { t } = useLang();
  const heroRef = useRef(null);
  const lanyardLeftOffset = 40;
  const lanyardHeight = typeof window !== 'undefined' ? window.innerHeight : 800; // 占满整个屏幕高度
  const lanyardScale = 0.8;
  const ropeTopPosition = -(50 + lanyardHeight / 10);
  const lanyardOverflowX = 620;
  const lanyardOverflowBottom = 240;

  if (!profile) return null;
  const lanyard = getLanyardContent(profile.lanyard);

  return (
    <section ref={heroRef} className="relative min-h-screen lg:h-screen overflow-hidden bg-dark">
      {/* Image Section */}
      <div
        className="relative z-30 flex h-55 w-full items-center justify-center bg-dark"
      >
        <img
          src={profile.bannerImage || '/image.png'}
          alt="顶部展示图"
          className="w-full h-full object-cover"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = '/image.png';
          }}
        />
      </div>

      {/* Content Section with Lanyard overlay */}
      <div
        className="relative bg-dark pt-20 pb-16 lg:pb-20"
      >
        {/* 3D Lanyard Component - Positioned to start from banner bottom */}
        {lanyard.visible && (
          <div
            className="hidden lg:block"
            style={{
              position: 'absolute',
              top: `${ropeTopPosition}px`,
              left: `calc(${lanyard.horizontal}% + ${lanyardLeftOffset}px)`,
              transform: `translateX(-50%) scale(${lanyardScale})`,
              height: `${lanyardHeight + lanyardOverflowBottom}px`,
              width: `calc(100% + ${lanyardOverflowX}px)`,
              pointerEvents: 'none',
              zIndex: 5,
              transformOrigin: 'top center',
              overflow: 'visible',
            }}
          >
            <div style={{ pointerEvents: 'none', overflow: 'visible' }}>
              <LanyardErrorBoundary>
                <Lanyard eventSource={heroRef} position={[0, 0, 45]} gravity={[0, -40, 0]} content={lanyard} />
              </LanyardErrorBoundary>
            </div>
          </div>
        )}

        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end">
            {/* Left side */}
            <div>
              {/* Title */}
              <h1 className="text-4xl lg:text-5xl font-bold mb-6 text-white">
                {t.greeting} <span className="text-white">{profile.name}</span>
              </h1>

              {/* Subtitle */}
              <p className="text-xl text-gray-300 mb-8">{profile.title}</p>

              {/* Description */}
              <p className="text-base text-white mb-12 leading-relaxed" style={{ maxWidth: '500px' }}>
                {profile.description}
              </p>

              {/* Contact Info */}
              <div className="space-y-4" style={{ maxWidth: '500px' }}>
                <div className="flex items-center gap-4 text-gray-300 border border-gray-700 rounded-lg p-4">
                  <img src="/location.png" alt="location" className="w-5 h-5 flex-shrink-0" />
                  <span>{profile.location}</span>
                </div>
                <div className="flex items-center gap-4 text-gray-300 border border-gray-700 rounded-lg p-4">
                  <img src="/email.png" alt="email" className="w-5 h-5 flex-shrink-0" />
                  <span>{profile.email}</span>
                </div>
                <div className="flex items-center gap-4 text-gray-300 border border-gray-700 rounded-lg p-4">
                  <img src="/phone.png" alt="phone" className="w-5 h-5 flex-shrink-0" />
                  <span>{profile.phone}</span>
                </div>
              </div>
            </div>

            {/* Right side - portrait conversation */}
            <div
              className="flex gap-8 items-stretch justify-end"
              style={{ height: '400px' }}
            >
              <PortraitChat image={profile.image} name={profile.name} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
